import { render } from "./PhotoClassifyPlatProp.vue?vue&type=template&id=74ceaea2&scoped=true"
import script from "./PhotoClassifyPlatProp.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyPlatProp.vue?vue&type=script&lang=js"

import "./PhotoClassifyPlatProp.vue?vue&type=style&index=0&id=74ceaea2&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ceaea2"]])

export default __exports__